'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { WidgetLocationProp } from 'conversations-visitor-experience-components/visitor-widget/constants/WidgetLocations';
import LauncherContainer from '../launcher/container/LauncherContainer';
import InitialMessageBubbleContainer from '../initial-message-bubble/containers/InitialMessageBubbleContainer';
import { withBrowserSizeContext } from '../containers/withBrowserSizeContext';
import WidgetWindow from './WidgetWindow';
import { FocusScope } from '@react-aria/focus';
import { AccessibilityContext } from 'conversations-visitor-message-history/accessibility/AccessibilityContext';
import QuickReplyGroupOutsideChat from './QuickReplyGroupOutsideChatContainer';
import { connect } from 'react-redux';
import { getIsUngatedForCustomerAgentPrompts } from '../widget-data/selectors/widgetDataSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class ApplicationLayout extends Component {
  constructor(props) {
    super(props);
    this.onOpenAnimationStarted = () => {
      this.setState({
        animationsFinished: false,
        shouldRenderDialog: true
      });
    };
    this.onOpenAnimationFinished = () => {
      this.setState({
        animationsFinished: true
      });
      this.context.setShouldTrapFocus(true);
    };
    this.onCloseAnimationStarted = () => {
      this.setState({
        animationsFinished: false
      });
    };
    this.onCloseAnimationFinished = () => {
      this.setState({
        animationsFinished: true,
        shouldRenderDialog: false
      });
      this.context.setShouldTrapFocus(false);
    };
    this.openWidget = this.openWidget.bind(this);
    this.closeWidget = this.closeWidget.bind(this);
    this.state = {
      animationsFinished: true,
      shouldRenderDialog: this.props.isOpen,
      hasOpened: false
    };
  }
  openWidget() {
    this.setState({
      animationsFinished: false
    });
    this.props.trackUserInteraction();
    this.props.toggleOpen({
      isOpened: true,
      isUser: true
    });
    this.context.setShouldTrapFocus(true);
  }
  closeWidget() {
    this.setState({
      animationsFinished: false,
      hasOpened: true
    });
    this.props.trackUserInteraction();
    this.props.toggleOpen({
      isOpened: false,
      isUser: true
    });
  }
  render() {
    const {
      isOpen,
      inline,
      mobile,
      onLauncherHover,
      showInitialMessageBubble,
      widgetLocation,
      speechPocActive,
      isUngatedForCustomerAgentPrompts
    } = this.props;
    const launcherHidden = isOpen && mobile || inline || isOpen && isUngatedForCustomerAgentPrompts;
    const showAskMeAnythingLauncher = isUngatedForCustomerAgentPrompts && !this.state.hasOpened;
    const showContent = !isUngatedForCustomerAgentPrompts || isUngatedForCustomerAgentPrompts && this.state.animationsFinished;
    return /*#__PURE__*/_jsx(AccessibilityContext.Consumer, {
      children: ({
        shouldTrapFocus
      }) => /*#__PURE__*/_jsxs(FocusScope, {
        contain: shouldTrapFocus,
        autoFocus: false,
        children: [/*#__PURE__*/_jsx(WidgetWindow, {
          inline: inline,
          isOpen: isOpen || inline,
          shouldRenderDialog: this.state.shouldRenderDialog,
          mobile: mobile,
          widgetLocation: widgetLocation,
          onOpenAnimationStarted: this.onOpenAnimationStarted,
          onCloseAnimationFinished: this.onCloseAnimationFinished,
          onOpenAnimationFinished: this.onOpenAnimationFinished,
          onCloseAnimationStarted: this.onCloseAnimationStarted,
          onClose: this.closeWidget,
          speechPocActive: speechPocActive,
          showAskMeAnythingLauncher: showAskMeAnythingLauncher
        }), showContent && /*#__PURE__*/_jsxs(_Fragment, {
          children: [showInitialMessageBubble && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(InitialMessageBubbleContainer, {
              onClick: this.openWidget,
              widgetLocation: widgetLocation
            }), /*#__PURE__*/_jsx(QuickReplyGroupOutsideChat, {
              widgetLocation: widgetLocation
            })]
          }), !launcherHidden && /*#__PURE__*/_jsx("span", {
            "data-test-id": 'chat-widget-launcher',
            onMouseOver: onLauncherHover,
            children: /*#__PURE__*/_jsx(LauncherContainer, {
              onClose: this.closeWidget,
              onOpen: this.openWidget,
              showAskMeAnythingLauncher: showAskMeAnythingLauncher,
              isUngatedForCustomerAgentPrompts: isUngatedForCustomerAgentPrompts
            })
          })]
        })]
      })
    });
  }
}
ApplicationLayout.displayName = 'ApplicationLayout';
ApplicationLayout.contextType = AccessibilityContext;
ApplicationLayout.propTypes = {
  inline: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isUngatedForCustomerAgentPrompts: PropTypes.bool.isRequired,
  mobile: PropTypes.bool.isRequired,
  onLauncherHover: PropTypes.func.isRequired,
  showInitialMessageBubble: PropTypes.bool.isRequired,
  speechPocActive: PropTypes.bool,
  toggleOpen: PropTypes.func.isRequired,
  trackUserInteraction: PropTypes.func.isRequired,
  widgetLocation: WidgetLocationProp
};
const mapStateToProps = state => ({
  isUngatedForCustomerAgentPrompts: getIsUngatedForCustomerAgentPrompts(state)
});
export default connect(mapStateToProps)(withBrowserSizeContext(ApplicationLayout));